import React, { useState } from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash/get';

import { Icon } from '../Icon';

const TextInput = props => {
  const [value, setValue] = useState(props.initialValue || '');
  const [hasFocus, setFocus] = useState(false);

  // We need to set an ID so that our label is tied to our input. If one is not
  // provided we need to generate one.
  const htmlId = get(props, 'inputProps.id') || `text-input-${props.name}`;
  const readOnly = !!get(props, 'inputProps.readOnly');
  const icon = (readOnly && 'lock-outlined') || props.icon;

  const handleBlur = event => {
    setFocus(false);
    props.onBlur && props.onBlur(event);
  };

  const handleChange = event => {
    setValue(event.target.value);
    props.onChange && props.onChange(event);
  };

  const handleFocus = event => {
    setFocus(true);
    props.onFocus && props.onFocus(event);
  };

  const getValue = () => {
    const valueProp = props.inputProps && props.inputProps.value;
    return valueProp !== undefined ? valueProp : value;
  };

  const wrapperClassNames = classNames('text-input', props.wrapperClass, {
    'text-input--with-icon': !!icon,
    'text-input--disabled': !!get(props, 'inputProps.disabled'),
  });

  const inputClassNames = classNames('text-input__input', props.inputClass, {
    'text-input__input--error': !!props.error,
  });

  const labelClassNames = classNames('text-input__label', props.labelClass, {
    'text-input__label--float': !!getValue() || hasFocus,
  });

  const Input = props.textarea ? 'textarea' : 'input';

  return (
    <div className={wrapperClassNames}>
      <div className="text-input__field-wrapper">
        <label className={labelClassNames} htmlFor={htmlId}>
          {props.labelText}
        </label>

        <Input
          className={inputClassNames}
          id={htmlId}
          name={props.name}
          onBlur={handleBlur}
          onChange={handleChange}
          onFocus={handleFocus}
          value={value}
          {...props.inputProps}
        />

        {icon && <Icon className="text-input__icon" name={icon} />}
      </div>

      {!!props.helperText && (
        <span className="text-input__helper-text input__helper-text">
          {props.helperText}
        </span>
      )}

      {!!props.error && (
        <span className="text-input__error toggle-input__error">
          {props.error}
        </span>
      )}
    </div>
  );
};

TextInput.propTypes = {
  error: propTypes.string,
  helperText: propTypes.string,
  icon: propTypes.string,
  initialValue: propTypes.string,
  inputClass: propTypes.string,
  inputProps: propTypes.object,
  labelClass: propTypes.string,
  labelText: propTypes.oneOfType([propTypes.string, propTypes.element])
    .isRequired,
  name: propTypes.string.isRequired,
  onBlur: propTypes.func,
  onChange: propTypes.func,
  onFocus: propTypes.func,
  textarea: propTypes.bool,
  wrapperClass: propTypes.string,
};

export default TextInput;
